import { BarChart } from "@mantine/charts";
import { SimpleGrid, Stack, Text } from "@mantine/core";
import type { AssistantUsageText } from "@/locales/assistant-usage";
import type { UsageDailyDto } from "@/types/ai-assistant-usage";

interface Props {
	daily: UsageDailyDto;
	t: AssistantUsageText;
}

const SECONDS_PER_MINUTE = 60;
const CHART_HEIGHT = 180;
const MINUTE_DECIMALS = 10;

/** Grafik batang 14 hari terakhir: token Claude & menit suara (garis acuan = batas harian bila diisi). */
export function CapDailyChart({ daily, t }: Props) {
	const tokenData = daily.points.map((p) => ({
		day: p.day.slice(5),
		[t.chartTokens]: p.chatTokens,
	}));
	const minuteData = daily.points.map((p) => ({
		day: p.day.slice(5),
		[t.chartMinutes]:
			Math.round((p.voiceSeconds / SECONDS_PER_MINUTE) * MINUTE_DECIMALS) /
			MINUTE_DECIMALS,
	}));
	const line = (y: number) =>
		y > 0 ? [{ y, label: t.chartLimitLine, color: "red.6" }] : [];
	return (
		<Stack gap="xs" data-usage-chart>
			<Text size="sm" fw={600}>
				{t.chartTitle}
			</Text>
			<SimpleGrid cols={{ base: 1, md: 2 }}>
				<Stack gap={4}>
					<Text size="xs" c="dimmed">
						{t.chartTokens}
					</Text>
					<BarChart
						h={CHART_HEIGHT}
						data={tokenData}
						dataKey="day"
						series={[{ name: t.chartTokens, color: "violet.6" }]}
						referenceLines={line(daily.chatTokenLimitDaily)}
						withLegend={false}
					/>
				</Stack>
				<Stack gap={4}>
					<Text size="xs" c="dimmed">
						{t.chartMinutes}
					</Text>
					<BarChart
						h={CHART_HEIGHT}
						data={minuteData}
						dataKey="day"
						series={[{ name: t.chartMinutes, color: "teal.6" }]}
						referenceLines={line(
							daily.voiceSecondsLimitDaily / SECONDS_PER_MINUTE,
						)}
						withLegend={false}
					/>
				</Stack>
			</SimpleGrid>
		</Stack>
	);
}
